import {projectHistoryURL} from "../../../services/api";
import {
    GET_PROJECT_HISTORY,
    GET_PROJECT_HISTORY_FAIL,
    LOADING_PROJECT_HISTORY,
    SET_FAIL_MESSAGE_HISTORY
} from "../actionTypes";
import {checkErrorMessage} from "../../../utils/utils";
import api from '../../../services/instanceapi'

export const getProjectHistory = (id, headers) => async (dispatch) => {
    dispatch({
        type: LOADING_PROJECT_HISTORY,
    });
    try{
        const projectHistory = await api.get(projectHistoryURL(id), headers)
        dispatch({
            type: GET_PROJECT_HISTORY,
            payload:{
                projectHistory:projectHistory.data
            }

        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type:GET_PROJECT_HISTORY_FAIL
                }
            )}
        dispatch({
            type:SET_FAIL_MESSAGE_HISTORY,
            payload:{
                message:message
            }
        })
    }
}